import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import AzureLocalSVG from '../../../assets/icons/clouds/azure-local.svg?raw';

export const AzureLocalLogo = (props) => <CustomSVG svg={AzureLocalSVG} preserveColors {...props} />;
